import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Field} from 'redux-form';
import {Table, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {InputField} from '../../../common/components/form';
import {tabKeyCode, enterKeyCode} from '../../../common/constants/keyCodes';
import {getNumericValue} from '../../../common/util/fieldsValidation';
import {stopEvent} from '../../../common/util/event';
import DeleteModal from '../deleteModal';

class TransferDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {'updatedPartInfo': false};
    this.onPartCodeKeyDown = this.onPartCodeKeyDown.bind(this);
    this.onQuantityKeyDown = this.onQuantityKeyDown.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.addNewItem = this.addNewItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {currentIndex, loading} = this.props;

    if (prevProps.loading && !loading && currentIndex !== null) {
      this.setState({'updatedPartInfo': true}, () => {
        setTimeout(() => this.focusQuantityField(currentIndex), 100);
      });
    }
  }

  focusQuantityField(index) {
    const element = document.getElementsByName(`detail[${index}].quantity`)[0];
    element.focus();
  }

  renderItems(fields) {
    return (
      <Table.Body>
        {fields.map((item, index) => this.renderRow(fields, item, index))}
      </Table.Body>
    );
  }

  renderRow(fields, item, index) {
    const row = fields.get(index);
    return (
      <Table.Row key={index}>
        <Table.Cell className='part-code' textAlign='center' width={2}>
          {this.renderPartCode(index, item, row)}
        </Table.Cell>
        <Table.Cell textAlign='center' width={4}>
          {row.partName}
        </Table.Cell>
        <Table.Cell className='part-quantity' textAlign='center' width={2}>
          {this.renderPartQuantity(index, item, row)}
        </Table.Cell>
        <Table.Cell textAlign='center' width={2}>
          {row.availableStock}
        </Table.Cell>
        <Table.Cell textAlign='center' width={2}>
          {'$'}
          {getNumericValue(row.cost, 2)}
        </Table.Cell>
        <Table.Cell textAlign='center' width={2}>
          {'$'}
          {this.renderTotalPrice(row)}
        </Table.Cell>
        <Table.Cell textAlign='center' width={2}>
          {this.renderItemActions(index, row)}
        </Table.Cell>
      </Table.Row>
    );
  }

  renderPartCode(index, item, row) {
    if (!row.lineNumber) {
      return (
        <Field
          name={`${item}.partCode`}
          component={InputField}
          onKeyDown={(event) => this.onPartCodeKeyDown(index, event)}
          autoFocus
          required
        />
      );
    }

    return row.partCode;
  }

  renderPartQuantity(index, item, row) {
    if (!row.lineNumber) {
      return (
        <Field
          name={`${item}.quantity`}
          component={InputField}
          onKeyDown={(event) => this.onQuantityKeyDown(index, row, event)}
          disabled={!this.state.updatedPartInfo}
          type='number'
          required
        />
      );
    }

    return row.quantity;
  }

  renderTotalPrice(row) {
    const {quantity, cost} = row;

    if (quantity && cost) {
      const total = parseInt(quantity, 10) * cost;
      return getNumericValue(total, 2);
    }

    return 0;
  }

  renderItemActions(index, row) {
    if (row.lineNumber) {
      return (
        <DeleteModal
          deleteFunction={() => this.deleteItem(index, row)}
          trigger={<Icon name='trash' size='big' link />}
        />
      );
    }

    return (
      <Icon
        name='close'
        size='big'
        color='red'
        link
        onClick={() => this.removeItem(index)}
      />
    );
  }

  onQuantityKeyDown(index, row, event) {
    const {code} = this.props;
    const value = event.target.value;

    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);

    if (!value || !row.partCode) {
      this.props.addMessageBoxError(
        'El código del repuesto y la cantidad son obligatorios'
      );
      return;
    }

    if (value <= 0 || value > row.availableStock) {
      this.props.addMessageBoxError(
        `El campo cantidad debe estar entre 1 y ${row.availableStock}`
      );
      return;
    }

    this.props.addTransferItem(code, index, {...row, 'quantity': value});
  }

  onPartCodeKeyDown(index, event) {
    const {origin} = this.props;

    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    stopEvent(event);

    if (event.target.value) {
      this.setState({'currentIndex': index});
      this.props.verifyStockInWarehouse(origin, event.target.value, index);
    }
  }

  addNewItem(fields) {
    this.setState({'updatedPartInfo': false}, () => fields.push({}));
  }

  removeItem(index) {
    this.setState({'updatedPartInfo': false}, () =>
      this.props.fields.remove(index)
    );
  }

  deleteItem(index, itemData) {
    const {code} = this.props;
    this.props.removeTransferItem(code, index, itemData);
  }

  render() {
    const {fields} = this.props;

    return (
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell textAlign='center'>
              <strong>Código Parte</strong>
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              <strong>Descripción</strong>
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              <strong>Cantidad</strong>
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              <strong>Cantidad Disponible</strong>
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              <strong>Costo Unitario</strong>
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              <strong>Costo Total</strong>
            </Table.HeaderCell>
            <Table.HeaderCell textAlign='center'>
              <strong>Acciones</strong>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {this.renderItems(fields)}
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan={7} textAlign='left'>
              <a
                className='add-element'
                onClick={() => this.addNewItem(fields)}
              >
                <strong>
                  <Icon name='add' size='large' />
                  AGREGAR REGISTRO
                </strong>
              </a>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  const {values, currentIndex, gettingInfo} = state.form.transfer;
  const {code, origin} = values || {};

  return {
    'loading': gettingInfo,
    'currentIndex': currentIndex,
    'warehouses': state.warehouses.list,
    'code': code,
    'origin': origin,
  };
};

const {
  addTransferItem,
  removeTransferItem,
  addMessageBoxError,
  verifyStockInWarehouse,
} = Actions;

export default connect(mapStateToProps, {
  addTransferItem,
  removeTransferItem,
  addMessageBoxError,
  verifyStockInWarehouse,
})(TransferDetail);
